<template>
    <div class="shade" v-if="show">
        <div class="pubDialog">
            <img class="closeImg" src="@/assets/images/vipNew/close.png" alt="" @click="closeDialog">
            <div class="pubTbox">
                <p class="changeT">天降机遇</p>
                <p class="getT">可获取1日免费发布公告机会</p>
            </div>
            <div class="tipsBox">
                <p>精准识别招标文件</p>
                <p>秒数生成合规公告</p>
                <p>多平台一键直达</p>
            </div>
            <div class="getPower" @click="getPower">立即领取</div>
            <p class="tipsWord">领取后24小时之内有效</p>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                show:false
            }
        },
        computed: {
           
        },
        methods:{
            //打开弹窗
            openDialog(){
                this.show= true
            },
            //关闭弹窗
            closeDialog(){
                this.show = false
            },

            //领取发公告次数
            getPower(){
                this.$get(`${this.$store.state.api.webUrl}/userobtain/receiveNotice`, {}, (data) =>{
                    if(data==0){  //0成功   1失败
                        this.closeDialog()
                        this.$get(`${this.$store.state.api.baseWebUrl}/dlms/login/getUrl`, {}, (data) => {
                            window.open(data);
                        });
                    }
                })
            }
        
        },
        mounted(){
          
        }
    }
</script>

<style lang="scss" scoped>
     .shade{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.4);
        z-index: 10000;
     }
     .pubDialog{
        position: fixed;
        top: 50%;
        left: 50%;
        width: 529px;
        height: 445px;
        margin-top: -222px;
        margin-left: -265px;
        background: url('../../../../assets/images/vipNew/pubBg.png') no-repeat 100% 100%;
     }
     .closeImg{
        position: absolute;
        top: 16px;
        right: 18px;
        width: 20px;
        height: 20px;
        z-index: 10;
        cursor: pointer;
     }
     .pubTbox{
        margin-left: 143px;
        margin-top: 53px;
     }
     .changeT{
        font-size: 20px;
        color: #000;  
        font-weight: 600;
     }
     .getT{
        font-size: 26px;
        color: #F93028;
        margin-top: 21px;
        font-weight: 600;
     }
     .tipsBox{
        width: 459px;
        height: 160px;
        margin: 0 auto;
        margin-top: 40px;
        background: url('../../../../assets/images/vipNew/descBg.png') no-repeat 100% 100%;
        text-align: center;
        color: #6D3A0B;
        font-size: 20px;
        padding: 15px;
        font-weight: 600;
        line-height: 44px;
     }
     .getPower{
        width: 262px;
        height: 46px;
        border-radius: 23px;
        background-color: #C2834A;
        color: #fff;
        text-align: center;
        line-height: 46px;
        margin: 0 auto;
        margin-top: 14px;
        font-size: 18px;
        cursor: pointer;
     }
     .tipsWord{
        text-align: center;
        color: #212121;
        font-size: 16px;
        margin-top: 12px;
     }
</style>